/** The element at the top of the page's main region that dialogs mount into (ADR-20261102-h2fd). */
export const DIALOG_ROOT_ID = "portal-dialog-root";
